  // Check if the cookie banner was acknowledged
  function checkCookieBanner() {
    if (localStorage.getItem('cookieBannerAcknowledged') !== 'TRUE') {
      showCookieBanner();
    }
  }

  // Show cookie banner
  function showCookieBanner() {
    const cookieBanner = document.querySelector('.banner-bar');
    if (cookieBanner) {
      cookieBanner.style.display = 'flex';

      // Start countdown ring animation
      const ring = cookieBanner.querySelector('.cookie-close__countdown');
      if (ring) {
        // Force reflow so the animation starts cleanly
        ring.getBoundingClientRect();
        ring.classList.add('--animating');
      }

      // Auto-close after 5 seconds
      const autoCloseTimer = setTimeout(() => {
        dismissBanner(cookieBanner);
      }, 5000);

      // Store timer so manual close can clear it
      cookieBanner._autoCloseTimer = autoCloseTimer;

      // Grant consent after 200ms (existing behaviour)
      setTimeout(() => {
        localStorage.setItem('cookieBannerAcknowledged', 'TRUE');
        updateConsent();
        loadGtagScript();
      }, 200);
    }
  }

  // Dismiss the banner
  function dismissBanner(banner) {
    if (banner) {
      banner.style.display = 'none';
    }
  }

  // Update consent with gtag
  function updateConsent() {
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('consent', 'update', {
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      ad_storage: 'granted',
      analytics_storage: 'granted'
    });
  }

  // Load the GTM script
  function loadGtagScript() {
    var gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-619838969';
    var firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(gtagScript, firstScript);
  }

  // Close cookie banner on button click
  function closeCookieBanner() {
    const closeButton = document.querySelector('.cookie-close');
    const cookieBanner = document.querySelector('.banner-bar');

    if (closeButton) {
      closeButton.addEventListener('click', function() {
        clearTimeout(cookieBanner._autoCloseTimer);
        dismissBanner(cookieBanner);
      });
    }
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', function() {
    checkCookieBanner();
    closeCookieBanner();
  });